import { isAutodetectedName } from '../../util/location-facts'

export interface ILocationFlag {
  id: string
  tone: 'warning' | 'info'
}

/**
 * Badges for the card title. A missing country or subdivision is not one of them -
 * those already read as facts underneath the title, and a badge as well would say it twice.
 */
export function getLocationFlags(location: { name: string; isDefault: boolean }): ILocationFlag[] {
  return [
    ...(location.isDefault ? [{ id: 'locations.default', tone: 'info' } as const] : []),
    ...(isAutodetectedName(location.name) ? [{ id: 'locationPlace.card.rename', tone: 'warning' } as const] : []),
  ]
}
